export default {
  sections: {
    alcohol_percentage: 'Alcoholpercentage: {{value}}%',
    price_per_unit: 'Prijs per {{unit}}: {{value}}',
    gtin: 'GTIN',
    ingredients: 'Ingrediënten',
    allergens: 'Allergenen',
    additives: 'Additieven',
    nutrition_breakdown: {
      title: 'Voedingsinformatie',
      description: '100 {{unit}} bevat:',
      items: {
        energy: 'Energie',
        fat: 'Vet',
        saturates: 'waarvan verzadigde vetzuren',
        carbohydrates: 'Koolhydraten',
        sugars: 'waarvan suikers',
        protein: 'Eiwit',
        salt: 'Zout',
      },
    },
  },
  units: {
    l: 'liter',
    kg: 'kilo',
    default: 'eenheid',
  },
};
